"use client";

import Link from "next/link";

export default function ContactCTA() {
  return (
    // <section className="bg-gradient-to-b from-teal-300 to-white p-6 md:px-16 m:py-[25px]">
    <section className="bg-gradient-to-b from-teal-300 to-white p-8 md:p-16 font-poppins">
      <div className="nimbus-container mx-auto px-4">
        <div className="max-w-2xl">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Start the Conversation
          </h2>

          {/* Description */}
          <p className="text-lg mb-6 text-gray-700">
            We&apos;re here to collaborate, consult, and create.
          </p>

          {/* Button */}
          <Link
          target="_blank"
            href="https://outlook.office.com/book/ContactUs@nimbusnode.co/?ismsaljsauthenabled"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-700 transition"
          >
            BOOK AN APPOINTMENT
          </Link>
        </div>
      </div>
    </section>
  );
}
